import api from "./api";
import { getArgs } from "../utils";

const route = "/access";

const AccessesService = {
  getAccesses: (filters) => api.get(`${route}/admin/all?${getArgs(filters)}`),
};
export default AccessesService;
